const initialState = {
  criteria: {
    system: {},
    buffer: {},
  },
  toolStarted: false,
};

export default function advisory(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    // START TOOL
    case 'ADVISORY_START_TOOL':
      return {
        ...state,
        toolStarted: true,
      };

    // STORE CRITERIA
    case 'ADVISORY_STORE_CRITERIA': {
      const criteria = { ...state.criteria };
      criteria[payload.for] = { ...criteria[payload.for], ...payload.criteria };
      return {
        ...state,
        criteria,
      };
    }

    // REMOVE CRITERIA
    case 'ADVISORY_REMOVE_CRITERIA': {
      const criteria = { ...state.criteria };
      payload.criteriaKeys.forEach((key) => {
        if (criteria[payload.for][key]) delete criteria[payload.for][key];
      });
      return {
        ...state,
        criteria,
      };
    }

    // RESET CRITERIA
    case 'ADVISORY_RESET_CRITERIA':
      return {
        ...state,
        criteria: initialState.criteria,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/advisory.js